import * as colorBlitzGroups from './color-blitz-groups.ts';
import * as colorCommonGroups from './color-common-groups';
import * as colorJohnnyGroups from './color-johnny-groups.ts';
import * as colorNomadGroups from './color-nomad-groups';
import * as colorSK2Groups from './color-sk2-groups.ts';
import * as colorVipHouseGroups from './color-viphouse-groups.ts';
import { BORDERS } from '../constants/borders';
import { GRADIENTS } from '../constants/gradients';
import { BLITZ_BUTTON } from './components/blitz-button.ts';
import { BUTTON } from './components/common-button';
import { JOHNNY_BUTTON } from './components/johnny-button';
import { NOMAD_BUTTON } from './components/nomad-button';
import { SK2_BUTTON } from './components/sk2-button.ts';
import { VIPHOUSE_BUTTON } from './components/viphouse-button.ts';

export const THEME = {
	colors: {
		text: {
			...colorCommonGroups.TEXT
		},
		background: {
			...colorCommonGroups.BACKGROUND
		},
		control: {
			...colorCommonGroups.CONTROL
		},
		transparent: {
			...colorCommonGroups.TRANSPARENT
		},
		icon: {
			...colorCommonGroups.ICON
		},
		tag: {
			...colorCommonGroups.TAG
		},
		gameTag: {
			...colorCommonGroups.GAME_TAG_LOGO
		},
		other: {
			...colorCommonGroups.OTHER
		}
	},
	gradient: {
		...GRADIENTS
	},
	borders: {
		...BORDERS
	},
	components: {
		buttons: BUTTON
	}
};

export const THEME_NOMAD = {
	colors: {
		text: {
			...colorNomadGroups.TEXT
		},
		background: {
			...colorNomadGroups.BACKGROUND
		},
		control: {
			...colorNomadGroups.CONTROL
		},
		transparent: {
			...colorCommonGroups.TRANSPARENT
		},
		icon: {
			...colorNomadGroups.ICON
		},
		tag: {
			...colorCommonGroups.TAG
		},
		gameTag: {
			...colorCommonGroups.GAME_TAG_LOGO
		},
		other: {
			...colorNomadGroups.OTHER
		}
	},
	gradient: {
		...GRADIENTS
	},
	borders: {
		...BORDERS
	},
	components: {
		buttons: NOMAD_BUTTON
	}
};

export const THEME_JOHNNY = {
	colors: {
		text: {
			...colorJohnnyGroups.TEXT
		},
		background: {
			...colorJohnnyGroups.BACKGROUND
		},
		control: {
			...colorJohnnyGroups.CONTROL
		},
		transparent: {
			...colorCommonGroups.TRANSPARENT
		},
		icon: {
			...colorJohnnyGroups.ICON
		},
		tag: {
			...colorCommonGroups.TAG
		},
		gameTag: {
			...colorCommonGroups.GAME_TAG_LOGO
		},
		other: {
			...colorJohnnyGroups.OTHER
		}
	},
	gradient: {
		...GRADIENTS
	},
	borders: {
		...BORDERS
	},
	components: {
		buttons: JOHNNY_BUTTON
	}
};

export const THEME_VIPHOUSE = {
	colors: {
		text: {
			...colorVipHouseGroups.TEXT
		},
		background: {
			...colorVipHouseGroups.BACKGROUND
		},
		control: {
			...colorVipHouseGroups.CONTROL
		},
		transparent: {
			...colorCommonGroups.TRANSPARENT
		},
		icon: {
			...colorVipHouseGroups.ICON
		},
		tag: {
			...colorCommonGroups.TAG
		},
		gameTag: {
			...colorCommonGroups.GAME_TAG_LOGO
		},
		other: {
			...colorVipHouseGroups.OTHER
		}
	},
	gradient: {
		...GRADIENTS
	},
	borders: {
		...BORDERS
	},
	components: {
		buttons: VIPHOUSE_BUTTON
	}
};

export const THEME_BLITZ = {
	colors: {
		text: {
			...colorBlitzGroups.TEXT
		},
		background: {
			...colorBlitzGroups.BACKGROUND
		},
		control: {
			...colorBlitzGroups.CONTROL
		},
		transparent: {
			...colorCommonGroups.TRANSPARENT
		},
		icon: {
			...colorBlitzGroups.ICON
		},
		tag: {
			...colorCommonGroups.TAG
		},
		gameTag: {
			...colorCommonGroups.GAME_TAG_LOGO
		},
		other: {
			...colorBlitzGroups.OTHER
		}
	},
	gradient: {
		...GRADIENTS
	},
	borders: {
		...BORDERS
	},
	components: {
		buttons: BLITZ_BUTTON
	}
};

export const THEME_SK2 = {
	colors: {
		text: {
			...colorSK2Groups.TEXT
		},
		background: {
			...colorSK2Groups.BACKGROUND
		},
		control: {
			...colorSK2Groups.CONTROL
		},
		transparent: {
			...colorCommonGroups.TRANSPARENT
		},
		icon: {
			...colorSK2Groups.ICON
		},
		tag: {
			...colorCommonGroups.TAG
		},
		gameTag: {
			...colorCommonGroups.GAME_TAG_LOGO
		},
		other: {
			...colorSK2Groups.OTHER
		}
	},
	gradient: {
		...GRADIENTS
	},
	borders: {
		...BORDERS
	},
	components: {
		buttons: SK2_BUTTON
	}
};

export type ThemeType = typeof THEME;

export const THEME_MAP: Record<string, ThemeType> = {
	default: THEME,
	nomad: THEME_NOMAD,
	johnny: THEME_JOHNNY,
	viphouse: THEME_VIPHOUSE,
	blitz: THEME_BLITZ,
	sk2: THEME_SK2
} as const;

export type ThemeName = keyof typeof THEME_MAP;
